var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, TemplateRef } from '@angular/core';
import { BpgEventsService } from 'src/app/bpg-events/bpg-events.service';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { UploadService } from 'src/app/bpg-self-services/d-i/upload.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DatePipe } from '@angular/common';
var PushNotificationComponent = /** @class */ (function () {
    function PushNotificationComponent(bpgEventsService, spinner, router, environment, datePipe, selfService, bpgCommonService, dialog, uploadService) {
        this.bpgEventsService = bpgEventsService;
        this.spinner = spinner;
        this.router = router;
        this.environment = environment;
        this.datePipe = datePipe;
        this.selfService = selfService;
        this.bpgCommonService = bpgCommonService;
        this.dialog = dialog;
        this.uploadService = uploadService;
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.timeOutError = false;
        this.chapterNotification = '';
        this.chapterList = [];
        this.notificationSuccess = false;
        this.notificationFailure = false;
        this.selectedFile = null;
        this.fileName = "Upload document(< 500MB)";
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.fileList = [];
        this.fileListName = [];
        this.removeToolbarHeaders = { disableNativeSpellChecker: false, autoParagraph: false, toolbar: 'Basic', extraPlugins: 'colorbutton', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Strike,Subscript,Superscript,RemoveFormat', height: '250px', maxLength: '2000', Backgroundcolor: 'black !important' };
        this.selectedSiteIds = [];
        this.emailList = [];
        this.memberUserId = [];
        this.selectedEmail = [];
        this.copySuccess = false;
        this.selectedUserList = [];
        this.selectedEmailString = '';
        this.showCustomDateRange = false;
        this.todaysDate = new Date();
        this.maxDate = new Date();
        this.showJoinedDateField = false;
        this.countOfSignedUser = 10;
        this.currentPage = 0;
        this.limit = ConstantValues.pageLimit;
        this.totalPages = 0;
        this.noMemberFound = false;
        this.currentShowingElements = ConstantValues.pageLimit;
        this.startDateGreaterError = false;
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
    }
    PushNotificationComponent.prototype.ngOnInit = function () {
        if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
            if (localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        this.adminId = localStorage.getItem('adminId');
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        if (localStorage.getItem('isbpgAdmin') == 'true') {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem('isbpgLeadAdmin') === 'true') {
            this.isbpgLeadAdmin = true;
        }
        if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
            this.router.navigate(['/site-home']);
        }
        // if (this.loginDetails == null) {
        //   this.router.navigate(['/login']);
        // }
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.userAndRoleIdDTO = {
            userId: this.loginData['userId'],
            roleId: localStorage.getItem('adminId')
        };
        this.bpgCommonService.getSessionToken();
        if (this.chapterNotification != null && this.chapterNotification != undefined && this.chapterNotification != '') {
            this.chapterNotificationSuccess = true;
        }
        if (this.chapterNotification == null || this.chapterNotification == undefined || this.chapterNotification == '') {
            this.chapterNotificationSuccess = false;
        }
        this.filterList =
            [{ filterId: 1, filterName: 'All' },
                { filterId: 2, filterName: 'Custom Date Range' },
                { filterId: 3, filterName: 'Last 7 days' },
                { filterId: 4, filterName: 'Last 30 days' },
                { filterId: 5, filterName: 'Last 6 Months' },
                { filterId: 6, filterName: 'Last 12 Months' }];
        //this.getAllChapters()
        this.getAllBpg();
    };
    PushNotificationComponent.prototype.getAllBpg = function () {
        var _this = this;
        var landingDto = {
            "filter": {},
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "",
            "uid": ""
        };
        this.selfService.getAllBpg(landingDto).subscribe(function (data) {
            _this.bpgList = data;
        });
    };
    /** For fetching site list
    * @class PushNotificationComponent
    * @method siteChange
    */
    PushNotificationComponent.prototype.bpgChange = function (event) {
        var _this = this;
        this.selectedEmail = [];
        this.selectedFilter = 1;
        this.startDate = null;
        this.endDate = null;
        this.noMemberFound = false;
        this.copySuccess = false;
        this.selectedSiteIds = [];
        this.memberUserId = [];
        this.emailList = [];
        this.siteId = null;
        this.siteList = [];
        if (event != undefined) {
            this.bpgId = event.bpgId;
        }
        this.selectedBpgsData =
            {
                "filter": {
                    "bpgId": this.bpgId,
                    "userId": this.userAndRoleIdDTO.userId,
                    "adminId": this.userAndRoleIdDTO.roleId
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "string",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "string",
                "uid": "string"
            };
        this.siteList = [];
        this.bpgCommonService.getMySiteList(this.selectedBpgsData).subscribe(function (data) {
            _this.siteList = data;
            _this.siteList.unshift({ siteId: 0, siteName: 'Select All' });
            for (var i = 0; i < _this.siteList.length; i++) {
                if (i == 0) {
                    _this.allSiteIds = _this.siteList[i].siteId;
                }
                else {
                    _this.allSiteIds = _this.allSiteIds + _this.siteList[i].siteId + ",";
                }
            }
        });
    };
    PushNotificationComponent.prototype.siteChange = function (e) {
        this.noMemberFound = false;
        this.copySuccess = false;
        for (var i_1 = 0; i_1 < e.length; i_1++) {
            if (e[i_1].siteId == 0 && e[i_1].siteName == 'Select All') {
                this.siteId = [];
                this.siteId = this.siteList;
                this.siteId = this.siteId.filter(function (m) { return m.siteName != 'Select All'; });
                break;
            }
        }
        if (this.siteId != null && this.bpgId != null && this.siteList.length > 0) {
            this.selectedSiteIds = [];
            if (this.siteId.length > 0) {
                for (var i = 0; i < this.siteId.length; i++) {
                    this.selectedSiteIds.push(this.siteId[i].siteId);
                }
            }
            this.getChapterMembersEmails();
        }
    };
    PushNotificationComponent.prototype.getChapterMembersEmails = function () {
        var _this = this;
        this.noMemberFound = false;
        this.startDateGreaterError = false;
        if (this.selectedFilter == 2 && this.startDate == null && this.endDate == null) {
            {
                this.showCustomDateRange = true;
                this.emailList = [];
            }
        }
        else if (this.selectedFilter == 2 && this.startDate != null && this.endDate != null && this.endDate < this.startDate) {
            this.startDateGreaterError = true;
        }
        else {
            if (this.showJoinedDateField) {
                this.spinner.show();
                if (this.selectedFilter != 2 || (this.selectedFilter == 2 && this.startDate != null && this.endDate != null)) {
                    if (this.selectedFilter != 2) {
                        this.startDate = null;
                        this.endDate = null;
                        this.showCustomDateRange = false;
                    }
                }
            }
            if (this.showJoinedDateField == false) {
                this.selectedFilter = 0;
                this.startDate = null;
                this.endDate = null;
            }
            this.allSiteIds = this.selectedSiteIds.toString();
            if (this.selectedFilter == 2 && this.startDate != null && this.endDate != null) {
                // this.startDate = this.startDate.toString()
                // this.startDate= this.datePipe.transform(this.startDate,'yyyy-MM-dd');
                // this.endDate= this.datePipe.transform(this.endDate,'yyyy-MM-dd');
            }
            this.selectedBpgsData =
                {
                    "filter": {
                        "bpgId": this.bpgId,
                        "userId": 0,
                        "siteId": this.allSiteIds,
                        "filterId": this.selectedFilter,
                        'startDate': this.startDate,
                        'endDate': this.endDate
                    },
                    "moduleId": 0,
                    "page": 0,
                    "presentRole": "string",
                    "searchTerm": "string",
                    "size": 0,
                    "sortDirection": "ASC",
                    "sortProperty": "string",
                    "uid": "string"
                };
            this.bpgCommonService.getChapterEmailList(this.selectedBpgsData).subscribe(function (data) {
                _this.spinner.hide();
                _this.emailList = [];
                _this.selectedEmail = [];
                _this.emailList = data;
                if (_this.emailList != null && _this.emailList != undefined) {
                    _this.noMemberFound = false;
                    _this.selectedEmail = [];
                    if (_this.emailList.length > 0) {
                        // this.emailList.unshift({ userId: 0, emailId: 'Select All' });
                        for (var i = 0; i < _this.emailList.length; i++) {
                            if (_this.emailList[i].emailId)
                                _this.selectedEmail.push(_this.emailList[i].emailId);
                        }
                    }
                }
                else {
                    _this.noMemberFound = true;
                }
            });
        }
    };
    PushNotificationComponent.prototype.sendEmail = function () {
        this.selectedEmailString = '';
        console.log(this.selectedEmail.length);
        for (var i = 0; i < this.selectedEmail.length; i++) {
            if (i == 0 && this.selectedEmail.length == 1) {
                this.selectedEmailString = this.selectedEmail[i];
            }
            else if (i == 0 && this.selectedEmail.length > 1) {
                this.selectedEmailString += this.selectedEmail[i] + ',';
            }
            else if (i != this.selectedEmail.length - 1 && i != 0) {
                this.selectedEmailString += this.selectedEmail[i] + ',';
            }
            else {
                this.selectedEmailString += this.selectedEmail[i];
            }
        }
        window.location.assign("mailto:" + this.selectedEmailString);
    };
    PushNotificationComponent.prototype.copyText = function () {
        this.selectedEmailString = '';
        this.copySuccess = true;
        for (var i = 0; i < this.selectedEmail.length; i++) {
            if (i == 0 && this.selectedEmail.length == 1) {
                this.selectedEmailString = this.selectedEmail[i];
            }
            else if (i == 0 && this.selectedEmail.length > 1) {
                this.selectedEmailString += this.selectedEmail[i] + ';';
            }
            else if (i != this.selectedEmail.length - 1 && i != 0) {
                this.selectedEmailString += this.selectedEmail[i] + ';';
            }
            else {
                this.selectedEmailString += this.selectedEmail[i];
            }
        }
        navigator.clipboard.writeText(this.selectedEmailString);
    };
    PushNotificationComponent.prototype.showJoinedDateFilter = function () {
        this.startDateGreaterError = false;
        this.showJoinedDateField = !this.showJoinedDateField;
        this.selectedFilter = 1;
    };
    PushNotificationComponent.prototype.emailChange = function (e) {
        // this.copySuccess = false
        for (var i = 0; i < e.length; i++) {
            if (e[i].userId == 0 && e[i].emailId == 'Select All') {
                this.selectedEmail = [];
                this.selectedEmail = this.emailList;
                this.selectedEmail = this.selectedEmail.filter(function (m) { return m.emailId != 'Select All'; });
                break;
            }
        }
    };
    PushNotificationComponent.prototype.removeText = function () {
        this.selectedEmail = [];
        this.emailList = [];
    };
    PushNotificationComponent.prototype.openAndCloseMatDialog = function (type) {
        if (type == 'open') {
            this.usersAdded = false;
            this.userExists = false;
            var dialogConfig = new MatDialogConfig();
            dialogConfig.height = "70vh";
            dialogConfig.width = "60vw";
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = false;
            var dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
            dialogRef.updatePosition({
                bottom: '5vh',
            });
        }
        else {
            this.userFound = false;
            this.searchTerm = null;
            this.userList = [];
            this.copySuccess = false;
            this.selectedUserList = [];
            this.userExists = false;
            this.usersAdded = false;
            this.userFirstName = '';
            var dialogConfig = new MatDialogConfig();
            var dialogRef = this.dialog.closeAll();
        }
    };
    PushNotificationComponent.prototype.searchBy = function () {
        //this.deleteSuccess = false;
        // this.clearError();
        // this.spinner.show(); 
        this.userExists = false;
        this.search = true;
        this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
        //this.landingDto.searchTerm = this.searchTerm;
        this.getUserList();
        //this.spinner.hide();   
    };
    /** to list users other than admins
  * @class AdminComponent
  * @method getUserList
  */
    PushNotificationComponent.prototype.getUserList = function () {
        var _this = this;
        this.timeOutError = false;
        this.selectedBpgsData =
            {
                "filter": {
                    "leadershipPosition": "USER"
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "",
                "searchTerm": this.searchTerm,
                "size": 10,
                "sortDirection": "ASC",
                "sortProperty": "um.user_first_name",
                "uid": "string"
            };
        this.selfService.getUserDropDown(this.selectedBpgsData).subscribe(function (data) {
            _this.userList = data;
            if (_this.userList.length == 0) {
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 500);
                _this.noUser = true;
                _this.userFound = false;
                // if(this.deleteSuccess == true  ){
                //   this.noUser = false;
                // }
            }
            else {
                if (_this.search) {
                    setTimeout(function () {
                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    }, 500);
                    _this.userFound = true;
                    _this.noUser = false;
                }
                _this.userList.map(function (i) { i.userFirstName = i.userFirstName + ' ' + i.userLastName; return i; });
            }
        }, function (err) {
            console.log(JSON.stringify(err.value.message));
            if (err.value.statusText == ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    PushNotificationComponent.prototype.userSelection = function ($event) {
        this.userExists = false;
        this.userFound = false;
        this.searchTerm = '';
        var index = this.emailList.indexOf($event);
        var index1 = this.selectedEmail.indexOf($event.emailId);
        var index2 = this.selectedUserList.indexOf($event);
        if (index === -1 && index1 === -1 && index2 == -1) {
            // val not found, pushing onto array
            this.selectedUserList.push($event);
            this.search = false;
        }
        else {
            this.userExists = true;
            this.userFound = false;
        }
    };
    PushNotificationComponent.prototype.removeUser = function (emailId) {
        var index = this.selectedUserList.indexOf(emailId);
        this.selectedUserList.splice(index, 1);
        this.search = false;
    };
    PushNotificationComponent.prototype.resetSelectedUser = function () {
        this.selectedUserList = [];
        this.userFound = false;
        this.searchTerm = null;
        this.userList = null;
        this.userFirstName = '';
        this.search = false;
        this.userExists = false;
        this.startDate = null;
        this.endDate = null;
        this.selectedFilter = null;
    };
    PushNotificationComponent.prototype.addUserToList = function () {
        this.userExists = false;
        this.method = "addUsersToEmailList";
        this.param = '';
        this.msg1 = 'Are you sure you want to add the Selected User(s) to "Email To List"?';
    };
    PushNotificationComponent.prototype.addUsersToEmailList = function () {
        for (var i = 0; i < this.selectedUserList.length; i++) {
            this.emailList = this.emailList.concat([{ userIid: this.selectedUserList[i].userId, emailId: this.selectedUserList[i].emailId }]);
            this.selectedEmail = this.selectedEmail.concat([this.selectedUserList[i].emailId]);
        }
        this.openAndCloseMatDialog('close');
        this.usersAdded = true;
        this.noMemberFound = false;
    };
    // getAllChapters() {
    //   this.spinner.show()
    //   var landingData = {
    //     "filter": {},
    //     "moduleId": 0,
    //     "page": 0,
    //     "presentRole": "string",
    //     "searchTerm": "string",
    //     "size": 0,
    //     "sortDirection": "DESC",
    //     "sortProperty": 'chapter_id',
    //     "uid": "string"
    //   }
    //   this.selfService.getAllChapter(landingData).subscribe(data => {
    //     if (data != null && data != undefined) {
    //       this.spinner.hide()
    //       this.chapterList = data;
    //       for (let i = 0; i < this.chapterList.length; i++) {
    //         this.chapterList[i].chapterName = this.chapterList[i].siteName + '-' + this.chapterList[i].bpgName
    //       }
    //     }
    //   }
    //   );
    // }
    /** checks if word exists in array
    * @class ConfigureGalleryComponent
    * @method isInArray
    */
    PushNotificationComponent.prototype.isInArray = function (array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    };
    PushNotificationComponent.prototype._handleReaderLoaded = function (readerEvt) {
        var binaryString = readerEvt.target.result;
        this.base64textString = btoa(binaryString);
    };
    PushNotificationComponent.prototype.deleteFile = function (d) {
        var index = this.fileList.indexOf(d);
        this.fileList.splice(index, 1);
        this.fileListName = [];
        this.fileName = '';
        if (this.fileList.length == 0) {
            this.fileName = "Upload < 500MB";
        }
        if (this.fileList.length > 0) {
            this.fileSize = 0;
            for (var i = 0; i < this.fileList.length; i++) {
                this.fileSize += this.fileList[i].size;
                if (this.fileSize > 524288000) {
                    this.fileSizeExtensionError = true;
                }
                else {
                    this.fileListName.push(this.fileList[i].name);
                    if (this.fileList.length == 1) {
                        this.fileName = this.fileList[i].name;
                    }
                    else {
                        this.fileName = this.fileName + " , " + this.fileList[i].name;
                    }
                }
            }
        }
    };
    /** For capturing files detail
  * @class PushNotificationComponent
  * @method onFileSelected
  */
    PushNotificationComponent.prototype.onFileSelected = function (event) {
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.selectedfileName = "";
        if (event.target.files.length > 0) {
            for (var i = 0; i < event.target.files.length; i++) {
                this.selectedfileName = event.target.files[i].name;
                this.fileSize += event.target.files[i].size;
                var allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "csv"];
                this.fileExtension = this.selectedfileName.split('.').pop();
                if (this.isInArray(allowedExtensions, this.fileExtension)) {
                    if (this.fileSize > 524288000) {
                        this.fileSizeExtensionError = true;
                    }
                    else {
                        this.fileExtensionError = false;
                        this.fileSizeExtensionError = false;
                        this.selectedFile = event.target.files[i];
                        this.fileList.push(this.selectedFile);
                        this.fileListName.push(this.selectedFile.name);
                        if (this.fileList.length == 1) {
                            this.fileName = this.selectedfileName;
                        }
                        else {
                            this.fileName = this.fileName + " , " + this.selectedfileName;
                        }
                    }
                }
                else {
                    this.fileExtensionError = true;
                    // this.fileName = "Upload < 500MB";
                }
            }
        }
    };
    /**To reset notification
   * @class PushNotificationComponent
   * @method resetClick
   */
    PushNotificationComponent.prototype.resetClick = function () {
        this.method = "resetClickConfirmation";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    /**To reset notification on confirmation
  * @class PushNotificationComponent
  * @method resetClickConfirmation
  */
    PushNotificationComponent.prototype.resetClickConfirmation = function () {
        this.startDateGreaterError = false;
        this.noMemberFound = false;
        this.copySuccess = false;
        this.bpgId = null;
        this.chapterNotification = '';
        this.subject = '';
        this.fileName = "Upload document(< 500MB)";
        this.selectedFile = null;
        this.fileList = [];
        this.fileSize = 0;
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.notificationSuccess = false;
        this.notificationFailure = false;
        this.selectedSiteIds = [];
        this.siteId = null;
        this.siteList = [];
        this.errorMsg = '';
        this.selectedEmail = [];
        this.emailList = [];
        this.spinner.hide();
    };
    /**To send Notification
  * @class PushNotificationComponent
  * @method sendNotification
  */
    PushNotificationComponent.prototype.sendNotification = function () {
        this.method = "onsendNotification";
        this.param = '';
        this.msg1 = " Are you sure you want to send notification ? ";
    };
    /**To send Notification on confirmation
  * @class PushNotificationComponent
  * @method onsendNotification
  */
    PushNotificationComponent.prototype.onsendNotification = function () {
        var _this = this;
        this.spinner.show();
        this.copySuccess = false;
        if (this.siteId.length > 0) {
            for (var i = 0; i < this.siteId.length; i++) {
                this.selectedSiteIds.push(this.siteId[i].siteId);
            }
        }
        if (this.selectedFile == null && this.fileName == "Upload document(< 500MB)") {
            this.fileName = "";
        }
        var notificationData = {
            "userId": this.loginDetails.userId,
            "notificationDesc": this.chapterNotification,
            "siteId": this.selectedSiteIds,
            "bpgId": this.bpgId,
            "fileNameList": this.fileListName,
            "subject": this.subject,
            "serviceFunction": 'saveData',
            "emailIdTo": this.selectedEmail.toString()
        };
        this.selfService.sendChapterNotification(notificationData).subscribe(function (data) {
            if (_this.fileName == '') {
                _this.fileName = "Upload document(< 500MB)";
            }
            if (data.message) {
                _this.errorMsg = data.message;
                _this.notificationSuccess = false;
                _this.notificationFailure = true;
                _this.spinner.hide();
            }
            else if (data.body != null && data.body != undefined && _this.fileList.length > 0) {
                var _loop_1 = function (i_2) {
                    notificationId = data.body.notificationId;
                    var uploadFlag = 'chapter_notification';
                    var uploadData = {
                        'category': 'uploadDocument',
                    };
                    _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var notificationData_1;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.awsUrls = data;
                                    return [4 /*yield*/, this.uploadService.getPresignedUrl(this.fileList[i_2], this.awsUrls, Number(notificationId), uploadFlag)];
                                case 1:
                                    _a.sent();
                                    //console.log("errorUpl" + localStorage.getItem('uploadError'));
                                    if (localStorage.getItem('uploadError') == 'Error') {
                                        this.notificationSuccess = false;
                                        this.notificationFailure = true;
                                        this.errorMsg = 'Failed to send the notification';
                                        this.spinner.hide();
                                    }
                                    else if (i_2 == this.fileList.length - 1 && localStorage.getItem('uploadError') != 'Error') {
                                        notificationData_1 = {
                                            "notificationId": notificationId,
                                            "serviceFunction": "savefile",
                                            "emailIdTo": this.selectedEmail.toString(),
                                            "siteId": this.selectedSiteIds,
                                            "bpgId": this.bpgId,
                                        };
                                        this.selfService.sendChapterNotification(notificationData_1).subscribe(function (data) {
                                            if (data.message) {
                                                _this.errorMsg = data.message;
                                                _this.notificationSuccess = false;
                                                _this.notificationFailure = true;
                                                _this.spinner.hide();
                                            }
                                            else if (data.body != null && data.body != undefined) {
                                                _this.notificationSuccess = true;
                                                _this.notificationFailure = false;
                                                if (_this.notificationSuccess) {
                                                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                                    setTimeout(function () {
                                                        _this.resetClickConfirmation();
                                                    }, 3000);
                                                }
                                            }
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                };
                var notificationId;
                for (var i_2 = 0; i_2 < _this.fileList.length; i_2++) {
                    _loop_1(i_2);
                }
            }
            else if (data.body != null && data.body != undefined && _this.fileList.length == 0) {
                _this.notificationSuccess = true;
                _this.notificationFailure = false;
                if (_this.notificationSuccess) {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    setTimeout(function () {
                        _this.resetClickConfirmation();
                    }, 3000);
                }
                //this.spinner.hide();
            }
        });
        // this.spinner.hide();
    };
    return PushNotificationComponent;
}());
export { PushNotificationComponent };
